var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.44 163.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #319966;\n      }\n\n      .cls-2 {\n        fill: #d4e2d6;\n        font-family: Marcher-Bold, Marcher;\n        font-size: 48px;\n        font-weight: 700;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArtboardDarkColours"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.89,
    y: 0.55,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(11.28 41.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.12,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.59 41.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.11,
    y: 54.24,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(10.71 95.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.37,
    y: 54.24,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.33 95.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.61,
    y: 54.24,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(118.21 95.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 109.16,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(7.66 150.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.37,
    y: 109.16,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(61.71 149.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.73,
    y: 109.16,
    width: 48.71,
    height: 48.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(115.34 150.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset18);
export default __webpack_public_path__ + "static/media/Asset18.44ff1cabf318675ef7595179b77d7bfb.svg";
export { ForwardRef as ReactComponent };